// デバッグモード: 在庫チェックを無効化
// 使用方法: ?debug_inventory=true を URL に追加
(function() {
  const urlParams = new URLSearchParams(window.location.search);
  const debugParam = urlParams.get('debug_inventory');
  
  if (debugParam === 'true') {
    localStorage.setItem('debug_inventory', 'true');
    console.log('[DEBUG] 在庫チェックを無効化しました');
  } else if (debugParam === 'false') {
    localStorage.removeItem('debug_inventory');
    console.log('[DEBUG] 在庫チェックを有効化しました');
  }
  
  window.DEBUG_INVENTORY = localStorage.getItem('debug_inventory') === 'true';
  if (window.DEBUG_INVENTORY) {
    console.log('[DEBUG] 在庫チェックは無効化されています');
  }
})();

document.addEventListener("DOMContentLoaded", function () {
  function initQuantityInputs() {
    const incrementButton = document.querySelector(".quantity-increment");
    const decrementButton = document.querySelector(".quantity-decrement");
    const quantityInput = document.getElementById("quantity");
    const quantitySelectWrapper = document.querySelector(".product-quantity-select");

    if(!quantityInput){
      return;
    }

    // data-selected-value を更新する関数
    function updateQuantityDataAttribute() {
      if (quantitySelectWrapper) {
        quantitySelectWrapper.setAttribute('data-selected-value', quantityInput.value);
      }
    }

    // 初期化時にdata-selected-valueを設定
    updateQuantityDataAttribute();

    // validate input (for select-based quantity)
    function validateQuantityInput() {
      let value = parseInt(quantityInput.value);
      let maxQuantity = parseInt(quantityInput.getAttribute('max')) || Infinity;

      if (isNaN(value) || value < 1) {
        quantityInput.value = 1;
      } else if (value > maxQuantity && maxQuantity > 0) {
        quantityInput.value = maxQuantity;
      }

      // data属性を更新
      updateQuantityDataAttribute();
      return true;
    }

    // select は change イベントで監視
    quantityInput.addEventListener("change", validateQuantityInput);

    // button event listeners
    if(incrementButton && decrementButton){
      incrementButton.addEventListener("click", function (event) {
        event.preventDefault();
        let currentValue = parseInt(quantityInput.value);
        let maxQuantity = parseInt(quantityInput.getAttribute('max')) || Infinity;
        
        if (!isNaN(currentValue) && (maxQuantity === 0 || currentValue < maxQuantity)) {
          quantityInput.value = currentValue + 1;
          validateQuantityInput();
        }
      });
      decrementButton.addEventListener("click", function (event) {
        event.preventDefault();
        let currentValue = parseInt(quantityInput.value);
        if (!isNaN(currentValue) && currentValue > 1) {
          quantityInput.value = currentValue - 1;
          validateQuantityInput();
        }
      });
    }
  }
  initQuantityInputs();

  function initProductVariantSelection() {
    const productData = window.productData;
    const optionSelectWrappers = document.querySelectorAll(".product-option-select");
    const productIdInput = document.getElementById("product-id");

    if (!productData || optionSelectWrappers.length === 0 || !productIdInput) {
      return;
    }

    // 初期化時にdata-selected-valueを設定
    function initSelectWrappers() {
      optionSelectWrappers.forEach((wrapper) => {
        const select = wrapper.querySelector('select');
        if (select) {
          const selectedOption = select.options[select.selectedIndex];
          wrapper.setAttribute('data-selected-value', selectedOption.text);
        }
      });
    }
    initSelectWrappers();

    // ページロード時にURLクエリパラメータまたはhiddenフィールドから初期バリアントを取得して状態を同期
    function initializeVariantState() {
      const currentVariantId = productIdInput.value;
      if (currentVariantId) {
        const currentVariant = productData.variants.find(v => v.id.toString() === currentVariantId.toString());
        if (currentVariant) {
          // 価格表示を更新（Liquidで既に設定されているが、念のため）
          updatePriceDisplay(currentVariant);
        }
      }
    }
    initializeVariantState();

    function updateSelectedVariant() {
      const selectedOptions = Array.from(optionSelectWrappers).map((wrapper) => {
        const select = wrapper.querySelector('select');
        return select ? select.value : '';
      });
      const matchedVariant = productData.variants.find((variant) => {
        return variant.options.every(
          (option, index) => option === selectedOptions[index]
        );
      });
      if (matchedVariant) {
        console.log(matchedVariant);
        productIdInput.value = matchedVariant.id;
        updatePriceDisplay(matchedVariant);
        updateQuantityAndBuyButton(matchedVariant);
      }
    }

    function formatMoney(value, currency = "JPY") {
      if (currency === "JPY") {
        // Shopifyの金額フォーマット（円の場合）
        const amount = (value / 100).toFixed(0);
        return `¥${parseFloat(amount).toLocaleString()}`;
      } else {
        // Shopifyの金額フォーマット（ドルの場合）
        const amount = (value / 100).toFixed(2);
        return `$${parseFloat(amount).toLocaleString()}`;
      }
    }

    function updatePriceDisplay(variant) {
      const priceElement = document.querySelector(".variant-price");
      const currency = window.currency || "JPY";
      if (priceElement && variant) {
        priceElement.textContent = formatMoney(variant.price, currency);
      }
    }
    
    async function updateQuantityAndBuyButton(variant) {
      if (!variant) return;
      
      // ローディング表示を開始
      const loadingElement = document.querySelector('.variant-loading');
      const buyButtonWrapper = document.querySelector('.buy-button-wrapper');
      
      if (loadingElement) {
        loadingElement.hidden = false;
      }
      if (buyButtonWrapper) {
        buyButtonWrapper.classList.add('is-loading');
      }
      
      try {
        // 現在の表示状態と数量値を保持
        const oldQuantityWrapper = document.querySelector('.quantity-wrapper');
        const wasHidden = oldQuantityWrapper ? oldQuantityWrapper.style.display === 'none' : false;
        const currentQuantityInput = document.getElementById("quantity");
        const currentQuantity = currentQuantityInput ? parseInt(currentQuantityInput.value) : 1;
        
        // Section Rendering APIを使用してバリアント情報を取得
        const productId = window.productData.id;
        const sectionId = document.querySelector('.product-area')?.dataset?.sectionId || 'product';
        const url = `${window.Shopify.routes.root}products/${window.productData.handle}?section_id=product&variant=${variant.id}`;
        
        const response = await fetch(url);
        const html = await response.text();
        
        // HTMLをパース
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // 新しいquantity-wrapper、buy-button-wrapper、addon-productsを取得
        const newQuantityWrapper = doc.querySelector('.quantity-wrapper');
        const newBuyButtonWrapper = doc.querySelector('.buy-button-wrapper');
        const newAddonProducts = doc.querySelector('.addon-products');
        
        // アドオン商品UIの表示/非表示を更新
        if (newAddonProducts) {
          const oldAddonProducts = document.querySelector('.addon-products');
          if (oldAddonProducts) {
            // 新しいHTMLから表示状態を取得
            const isVisible = newAddonProducts.style.display !== 'none';
            oldAddonProducts.style.display = isVisible ? '' : 'none';
          }
        } else {
          // 新しいHTMLにアドオン商品UIがない場合は非表示
          const oldAddonProducts = document.querySelector('.addon-products');
          if (oldAddonProducts) {
            oldAddonProducts.style.display = 'none';
          }
        }
        
        if (newQuantityWrapper) {
          const oldQuantityWrapper = document.querySelector('.quantity-wrapper');
          if (oldQuantityWrapper) {
            // 新しいHTMLから表示状態を取得
            let isVisible = newQuantityWrapper.style.display !== 'none';
            
            // デバッグモード時は強制的に表示
            if (window.DEBUG_INVENTORY && !isVisible) {
              console.log('[DEBUG] 売り切れバリアントの数量セレクターを強制的に表示します');
              isVisible = true;
            }
            
            oldQuantityWrapper.innerHTML = newQuantityWrapper.innerHTML;
            
            // innerHTML更新後に表示状態を設定
            oldQuantityWrapper.style.display = isVisible ? '' : 'none';
            
            // data-variant-idを更新
            oldQuantityWrapper.setAttribute('data-variant-id', variant.id);
            
            // 数量値を設定
            const newQuantityInput = oldQuantityWrapper.querySelector('#quantity');
            if (newQuantityInput) {
              let maxQuantity = parseInt(newQuantityInput.getAttribute('max')) || Infinity;
              
              // デバッグモード時はmax属性を大きな値に設定
              if (window.DEBUG_INVENTORY && maxQuantity === 0) {
                maxQuantity = 999;
                newQuantityInput.setAttribute('max', maxQuantity);
                console.log('[DEBUG] 数量セレクターのmax属性を999に設定しました');
              }

              // 売り切れバリアント（非表示状態）から購入可能バリアントに切り替える場合は1に設定
              if (wasHidden && isVisible) {
                newQuantityInput.value = 1;
              } else if (currentQuantity <= maxQuantity && currentQuantity > 0) {
                // 以前の数量値を復元（在庫数以下で1以上の場合）
                newQuantityInput.value = currentQuantity;
              } else if (maxQuantity > 0) {
                // 在庫数を超える場合は1に設定
                newQuantityInput.value = 1;
              } else {
                newQuantityInput.value = 1;
              }
              
              // data-selected-value属性も更新
              const quantitySelectWrapper = oldQuantityWrapper.querySelector('.product-quantity-select');
              if (quantitySelectWrapper) {
                quantitySelectWrapper.setAttribute('data-selected-value', newQuantityInput.value);
              }
            }
            
            // イベントリスナーを再初期化
            initQuantityInputs();
          }
        }
        
        if (newBuyButtonWrapper) {
          const oldBuyButtonWrapper = document.querySelector('.buy-button-wrapper');
          if (oldBuyButtonWrapper) {
            oldBuyButtonWrapper.innerHTML = newBuyButtonWrapper.innerHTML;
            oldBuyButtonWrapper.classList.remove('is-loading');
            
            // デバッグモード時：購入ボタンが存在しない場合は作成
            if (window.DEBUG_INVENTORY) {
              const addToCartButton = oldBuyButtonWrapper.querySelector('.add-to-cart-button');
              if (!addToCartButton) {
                console.log('[DEBUG] 購入ボタンが存在しないため、デバッグ用ボタンを作成します');
                const debugButton = document.createElement('button');
                debugButton.type = 'submit';
                debugButton.className = 'add-to-cart-button add-to-cart-button--debug';
                debugButton.textContent = '[DEBUG] カートに追加';
                debugButton.style.cssText = 'background: #ff6b6b; color: white; padding: 1rem 2rem; border: none; cursor: pointer; width: 100%;';
                oldBuyButtonWrapper.appendChild(debugButton);
              }
            }
            
            // フォーム送信イベントを再初期化
            initAddToCartForm();
          }
        }
        
        // バリアント変更後、product-option-selectのdata-selected-valueを再設定
        const updatedWrappers = document.querySelectorAll('.product-option-select');
        updatedWrappers.forEach((wrapper) => {
          const select = wrapper.querySelector('select');
          if (select) {
            const selectedOption = select.options[select.selectedIndex];
            wrapper.setAttribute('data-selected-value', selectedOption.text);
          }
        });
        
      } catch (error) {
        console.error('Error updating quantity and buy button:', error);
      } finally {
        // ローディング表示を終了
        if (loadingElement) {
          loadingElement.hidden = true;
        }
        if (buyButtonWrapper) {
          buyButtonWrapper.classList.remove('is-loading');
        }
      }
    }

    // select要素のchangeイベントでdata-selected-valueを更新
    optionSelectWrappers.forEach((wrapper) => {
      const select = wrapper.querySelector('select');
      if (select) {
        select.addEventListener("change", function() {
          const selectedOption = select.options[select.selectedIndex];
          wrapper.setAttribute('data-selected-value', selectedOption.text);
          updateSelectedVariant();
        });
      }
    });
  }
  initProductVariantSelection();

  // submit form via AJAX
  function initAddToCartForm() {
    const addToCartForm = document.querySelector(".shopify-product-form");
    if (!addToCartForm) {
      return;
    }
    
    // 既にイベントリスナーが設定されている場合はスキップ
    if (addToCartForm.dataset.listenerAttached === 'true') {
      return;
    }
    
    // イベントリスナーが設定されたことをマーク
    addToCartForm.dataset.listenerAttached = 'true';
    
    addToCartForm.addEventListener("submit", async function (event) {
      event.preventDefault();
      const formData = new FormData(addToCartForm);
      const formObject = {};
      formData.forEach((value, key) => {
        formObject[key] = value;
      });
      
      // カート内の在庫チェック（デバッグモードでは無効化）
      if (!window.DEBUG_INVENTORY) {
        try {
          const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          });
          const cartData = await cartResponse.json();
          
          // 追加しようとしているバリアントID
          const variantIdToAdd = formObject.id;
          const quantityToAdd = parseInt(formObject.quantity) || 1;
          
          // カート内の同じバリアントの合計数量を計算
          let existingQuantity = 0;
          cartData.items.forEach(function(item) {
            if (item.variant_id == variantIdToAdd) {
              existingQuantity += item.quantity;
            }
          });
          
          // 現在のバリアントの在庫数を取得
          const quantityInput = document.getElementById('quantity');
          const maxInventory = parseInt(quantityInput.getAttribute('max')) || Infinity;
          
          // 合計数量が在庫を超えるかチェック
          const totalQuantity = existingQuantity + quantityToAdd;
          if (maxInventory > 0 && totalQuantity > maxInventory) {
            const message = window.overQuantityMessage || '在庫数を超える数量は追加できません。';
            alert(message);
            return; // カート投入をキャンセル
          }
        } catch (error) {
          console.error('Error checking cart inventory:', error);
        }
      } else {
        console.log('[DEBUG] カート投入時の在庫チェックをスキップしました');
      }
      
      // selectで"true"が選択されたアドオン商品を取得
      const selectedAddons = [];
      const addonSelects = document.querySelectorAll('.addon-products select');
      
      // HTMLタグを除去してプレーンテキストを取得
      let mainProductTitle = '';
      if (window.productData && window.productData.title) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = window.productData.title;
        mainProductTitle = tempDiv.textContent || tempDiv.innerText || '';
      }
      
      const locale = window.shopLocale || 'ja';
      
      // ロケールに応じたプロパティキー
      const propertyKey = locale === 'en' ? 'Option for' : '関連商品';
      const mainPropertyKey = locale === 'en' ? 'Selected Options' : 'オプション';
      
      // 一意のグループIDを生成（親商品とアドオン商品を紐付けるため）
      const addonGroupId = 'addon_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      
      // 親商品のvariant IDを取得
      const parentVariantId = formObject.id;
      
      console.log('Generated addon group ID:', addonGroupId);
      console.log('Parent variant ID:', parentVariantId);
      
      // 選択されたアドオン商品のタイトルを収集
      const selectedAddonTitles = [];
      
      addonSelects.forEach((select) => {
        const selectedOption = select.options[select.selectedIndex];
        // value="true"が選択されている場合のみアドオンとして追加
        if (selectedOption.value === 'true') {
          const addonProductTitle = selectedOption.getAttribute('data-addon-product-title');
          selectedAddonTitles.push(addonProductTitle);
          
          selectedAddons.push({
            id: selectedOption.getAttribute('data-addon-product-id'),
            quantity: parseInt(formObject.quantity) || 1,
            properties: {
              '_addon_group_id': addonGroupId,
              '_is_addon': 'true',
              '_parent_product_id': parentVariantId,
              [propertyKey]: mainProductTitle
            }
          });

        }
      });
      
      try {
        // アドオン商品をカートに追加
        if (selectedAddons.length > 0) {
          console.log('Adding addon products with properties:', selectedAddons);
          const addonResponse = await fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              items: selectedAddons
            }),
          });
          const addonData = await addonResponse.json();
          console.log("Addon items added to cart:", addonData);
        }
        
        // メイン商品にオプション情報を追加
        const mainProductData = {
          ...formObject
        };
        
        // オプションが選択されている場合、プロパティを追加
        if (selectedAddonTitles.length > 0) {
          mainProductData.properties = {
            '_addon_group_id': addonGroupId,
            [mainPropertyKey]: selectedAddonTitles.join(', ')
          };
        }
        
        console.log('Adding main product with data:', mainProductData);
        
        // メイン商品をカートに追加
        const mainResponse = await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(mainProductData),
        });
        const mainData = await mainResponse.json();
        console.log("Main item added to cart:", mainData);
        
        // カートページにリダイレクト
        window.location.href = window.Shopify.routes.root + "cart";
      } catch (error) {
        console.error("Error adding to cart:", error);
      }
    });
  }
  initAddToCartForm();

  // Product image gallery switcher
  function initProductImageGallery() {
    const thumbLinks = document.querySelectorAll('.product-image-switch');
    const mainImages = document.querySelectorAll('.product-image-main');
    const prevButton = document.querySelector('.product-images__nav--prev');
    const nextButton = document.querySelector('.product-images__nav--next');
    const mainImagesContainer = document.querySelector('.product-images__main');

    // console.log(thumbLinks);
    // console.log(mainImages);
    
    if (thumbLinks.length === 0 || mainImages.length === 0) {
      return;
    }

    // 現在のアクティブな画像のインデックスを取得
    function getCurrentIndex() {
      for (let i = 0; i < mainImages.length; i++) {
        if (mainImages[i].classList.contains('is-active')) {
          return i;
        }
      }
      return 0;
    }

    // 指定したインデックスの画像に切り替え
    function switchToImage(imageIndex) {
      if (imageIndex < 0 || imageIndex >= mainImages.length) {
        return;
      }

      // Remove is-selected class from all thumbnails
      thumbLinks.forEach((thumb) => thumb.classList.remove('is-selected'));
      
      // Add is-selected class to corresponding thumbnail
      if (thumbLinks[imageIndex]) {
        thumbLinks[imageIndex].classList.add('is-selected');
      }
      
      // Remove is-active class from all main images
      mainImages.forEach((img) => img.classList.remove('is-active'));
      
      // Add is-active class to corresponding main image
      if (mainImages[imageIndex]) {
        mainImages[imageIndex].classList.add('is-active');
        // if(typeof lenis !== 'undefined' && lenis){
        //   lenis.scrollTo(
        //     document.querySelector('.product-images__main'),
        //     {
        //       offset: 0,
        //       duration: 1,
        //       offset: -100,
        //       easing: (t) => 1 - Math.pow(1 - t, 4),
        //     }
        //   );
        // }
      }

      // 前後ボタンの有効/無効を更新
      updateNavButtons(imageIndex);
    }

    // 前後ボタンの有効/無効を更新
    function updateNavButtons(currentIndex) {
      if (prevButton) {
        prevButton.disabled = currentIndex === 0;
      }
      if (nextButton) {
        nextButton.disabled = currentIndex === mainImages.length - 1;
      }
    }

    // サムネイルクリックイベント
    thumbLinks.forEach((link) => {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        console.log('Thumbnail clicked');
        const imageIndex = parseInt(this.getAttribute('data-image-index'));
        switchToImage(imageIndex);
      });
    });

    // 前へボタンのクリックイベント
    if (prevButton) {
      prevButton.addEventListener('click', function(event) {
        event.preventDefault();
        const currentIndex = getCurrentIndex();
        if (currentIndex > 0) {
          switchToImage(currentIndex - 1);
        }
      });
    }

    // 次へボタンのクリックイベント
    if (nextButton) {
      nextButton.addEventListener('click', function(event) {
        event.preventDefault();
        const currentIndex = getCurrentIndex();
        if (currentIndex < mainImages.length - 1) {
          switchToImage(currentIndex + 1);
        }
      });
    }

    // スワイプ機能の実装
    if (mainImagesContainer) {
      let touchStartX = 0;
      let touchEndX = 0;
      let touchStartY = 0;
      let touchEndY = 0;
      let isSwiping = false;
      const minSwipeDistance = 50; // 最小スワイプ距離（ピクセル）

      mainImagesContainer.addEventListener('touchstart', function(event) {
        touchStartX = event.changedTouches[0].screenX;
        touchStartY = event.changedTouches[0].screenY;
        isSwiping = false;
      }, { passive: true });

      mainImagesContainer.addEventListener('touchmove', function(event) {
        if (!isSwiping) {
          const touchCurrentX = event.changedTouches[0].screenX;
          const touchCurrentY = event.changedTouches[0].screenY;
          const diffX = Math.abs(touchCurrentX - touchStartX);
          const diffY = Math.abs(touchCurrentY - touchStartY);
          
          // 横方向のスワイプが縦方向より大きい場合、スワイプモードとして扱う
          if (diffX > diffY && diffX > 10) {
            isSwiping = true;
          }
        }
        
        // スワイプモードの場合、デフォルトのスクロールを防止
        if (isSwiping) {
          event.preventDefault();
        }
      }, { passive: false });

      mainImagesContainer.addEventListener('touchend', function(event) {
        touchEndX = event.changedTouches[0].screenX;
        touchEndY = event.changedTouches[0].screenY;
        handleSwipe();
        isSwiping = false;
      }, { passive: true });

      function handleSwipe() {
        const swipeDistanceX = touchEndX - touchStartX;
        const swipeDistanceY = touchEndY - touchStartY;
        
        // 縦方向のスワイプが横方向より大きい場合はスクロールとみなす
        if (Math.abs(swipeDistanceY) > Math.abs(swipeDistanceX)) {
          return;
        }

        const currentIndex = getCurrentIndex();

        // 右スワイプ（前の画像へ）
        if (swipeDistanceX > minSwipeDistance && currentIndex > 0) {
          switchToImage(currentIndex - 1);
        }
        // 左スワイプ（次の画像へ）
        else if (swipeDistanceX < -minSwipeDistance && currentIndex < mainImages.length - 1) {
          switchToImage(currentIndex + 1);
        }
      }
    }

    // 初期状態でボタンの有効/無効を設定
    updateNavButtons(getCurrentIndex());
  }
  initProductImageGallery();
  
});
